import { Controller } from "@hotwired/stimulus"

export default class AutoSubmitPermissionsController extends Controller {
  connect() {
    this.element.addEventListener("change", () => this.addSubmitButtonClickItAndRemove())
  }

  // Hack to get around form.submit() doesn't call submit event listeners unless submitted through a click on a button
  addSubmitButtonClickItAndRemove() {
    const form = this.element
    const fakeSubmitButton = document.createElement("input")

    fakeSubmitButton.type = "submit"

    form.appendChild(fakeSubmitButton)
    fakeSubmitButton.click()
    form.removeChild(fakeSubmitButton)
  }
}
